import { SimpleGrid as F, Flex as E, Stack as v, Image as k, rem as h, Box as f, Group as R, Grid as B, NumberFormatter as m, Divider as D } from "@mantine/core";
import e, { useMemo as S } from "react";
import { spacingSemanticTokens as p } from "@huspy/briks-core";
import { Text as a } from "@huspy/briks-web";
import b from "clsx";
import { c as z } from "./css-DAV6FxX7.mjs";
import { Check as M } from "@huspy/briks-icons";
function I() {
  return (/* @__PURE__ */ new Date()).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric"
  });
}
const V = ({
  brokerName: t,
  clientName: o,
  title: n = "Mortgage Proposal",
  brokerageLogo: l,
  brokerageName: r
}) => /* @__PURE__ */ e.createElement(F, { cols: 2 }, /* @__PURE__ */ e.createElement(E, { direction: "column" }, /* @__PURE__ */ e.createElement(a, { size: "5xl", color: "neutral.900", weight: "medium" }, n), /* @__PURE__ */ e.createElement(v, { gap: p["spacing-4"], mt: p["spacing-8"] }, /* @__PURE__ */ e.createElement(a, { size: "3xl", color: "#666" }, "Prepared for", " ", o, " ", "by", " ", t), /* @__PURE__ */ e.createElement(a, { m: "0 0 .5rem 0", size: "xl", color: "#666" }, I()))), l ? /* @__PURE__ */ e.createElement(E, { justify: "center", align: "center" }, /* @__PURE__ */ e.createElement(
  k,
  {
    src: l,
    w: "auto",
    h: "auto",
    maw: h(450),
    mah: h(100)
  }
)) : /* @__PURE__ */ e.createElement(a, { size: "6xl" }, r)), j = ({
  employmentStatus: t,
  location: o,
  mortgageLength: n,
  mortgageType: l,
  citizenStatus: r,
  typeOfTransaction: i,
  primaryColor: s
}) => {
  const _ = [
    { name: "Employment status", value: t },
    { name: "Mortgage type", value: l },
    { name: "Residency status", value: r },
    { name: "Transaction type", value: i },
    { name: "Mortgage length", value: n },
    { name: "Location", value: o }
  ];
  return /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(
    f,
    {
      w: h(270),
      p: p["spacing-10"],
      ta: "center",
      style: { backgroundColor: s }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "md",
        style: { color: "white" },
        weight: "semiBold"
      },
      "Financial requirements"
    )
  ), /* @__PURE__ */ e.createElement(R, { gap: 0, grow: !0 }, _.map(({ name: u, value: c }, y) => /* @__PURE__ */ e.createElement(
    f,
    {
      p: p["spacing-12"],
      style: {
        border: "1px solid black",
        ...y + 1 !== _.length && { borderRight: "none" },
        borderColor: s
      },
      key: u
    },
    /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, u),
    /* @__PURE__ */ e.createElement(a, { size: "md" }, c)
  ))));
}, T = {
  buyoutAndEquity: "Buyout + Equity",
  buyout: "Buyout",
  equity: "Equity"
}, U = (t) => t === T.buyoutAndEquity, L = (t) => [
  T.buyout,
  T.buyoutAndEquity,
  T.equity
].includes(t), G = ({
  downpayment: t,
  loanAmount: o,
  loanToValueRatio: n,
  propertyValue: l,
  primaryColor: r,
  typeOfTransaction: i,
  equityReleaseAmount: s,
  landDepartmentFeeFinancedAmount: _ = 0,
  realEstateFeeFinancedAmount: u = 0
}) => {
  const c = S(() => {
    let y = "No";
    u && !_ ? y = "Real Estate" : !u && _ ? y = "Land Department" : u && _ && (y = "Real Estate, Land Department");
    const g = {
      propertyValue: { name: "Property value", value: l, preffix: "AED " },
      equityReleaseAmount: { name: "Equity release amount", value: s, preffix: "AED " },
      loanValue: { name: "Loan to value (LTV/FTV)", value: n, suffix: "%" },
      // eslint-disable-next-line max-len
      feeFinancing: { name: "Fee financing", value: y },
      downPayment: { name: "Down payment", value: t, preffix: "AED " }
    };
    return L(i) && s ? [g.propertyValue, g.equityReleaseAmount, g.loanValue, g.feeFinancing] : [g.propertyValue, g.downPayment, g.loanValue, g.feeFinancing];
  }, [i]);
  return /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(
    f,
    {
      w: h(270),
      p: p["spacing-10"],
      ta: "center",
      style: { backgroundColor: r }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "md",
        style: { color: "white" },
        weight: "semiBold"
      },
      "Loan amount"
    )
  ), /* @__PURE__ */ e.createElement(B, { gutter: 0 }, c.map(({
    name: y,
    value: g,
    preffix: A,
    suffix: q
  }) => /* @__PURE__ */ e.createElement(B.Col, { span: 2, key: y }, /* @__PURE__ */ e.createElement(
    E,
    {
      direction: "column",
      justify: "center",
      px: p["spacing-12"],
      h: h(140),
      style: {
        border: "1px solid black",
        borderRight: "none",
        borderColor: r
      },
      key: y
    },
    /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, y),
    /* @__PURE__ */ e.createElement(a, { size: "md" }, typeof g == "number" ? /* @__PURE__ */ e.createElement(
      m,
      {
        value: g,
        thousandSeparator: ",",
        prefix: A,
        suffix: q
      }
    ) : g)
  ))), /* @__PURE__ */ e.createElement(B.Col, { span: 4 }, /* @__PURE__ */ e.createElement(
    E,
    {
      direction: "column",
      justify: "center",
      px: p["spacing-12"],
      py: p["spacing-16"],
      h: h(140),
      style: { border: "1px solid black", borderColor: r },
      flex: 1
    },
    /* @__PURE__ */ e.createElement(v, { gap: p["spacing-6"], h: "100%" }, /* @__PURE__ */ e.createElement(E, { justify: "space-between" }, U(i) && s ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Outstanding Loan Amount"), /* @__PURE__ */ e.createElement(a, { size: "md" }, /* @__PURE__ */ e.createElement(
      m,
      {
        prefix: "AED ",
        value: o - s,
        thousandSeparator: ","
      }
    ))) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Original loan amount"), /* @__PURE__ */ e.createElement(a, { size: "md" }, /* @__PURE__ */ e.createElement(
      m,
      {
        prefix: "AED ",
        value: o,
        thousandSeparator: ","
      }
    )))), /* @__PURE__ */ e.createElement(E, { justify: "space-between" }, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Real estate fee financed amount"), /* @__PURE__ */ e.createElement(a, { size: "md" }, /* @__PURE__ */ e.createElement(
      m,
      {
        prefix: "AED ",
        value: u,
        thousandSeparator: ","
      }
    ))), /* @__PURE__ */ e.createElement(E, { justify: "space-between" }, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Land department fee financed amount"), /* @__PURE__ */ e.createElement(a, { size: "md" }, /* @__PURE__ */ e.createElement(
      m,
      {
        prefix: "AED ",
        value: _,
        thousandSeparator: ","
      }
    ))), /* @__PURE__ */ e.createElement(D, { size: "md", color: r }), /* @__PURE__ */ e.createElement(E, { justify: "space-between" }, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Total loan amount"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, /* @__PURE__ */ e.createElement(
      m,
      {
        prefix: "AED ",
        value: o + u + _,
        thousandSeparator: ","
      }
    ))))
  ))));
}, x = ["#FCFAF6", "#F7F2E9", "#F0E7D6"], d = {
  table: z({
    borderCollapse: "separate",
    borderSpacing: 0,
    tableLayout: "fixed"
  }),
  thBase: z({
    padding: "0.438rem",
    border: "0.666px solid #999",
    "&:not(:last-child)": { borderRight: 0 }
  }),
  banksTh: z({
    borderTopLeftRadius: "6.657px",
    borderTopRightRadius: "6.657px",
    position: "relative"
  }),
  itemTh: z({ borderTop: 0, backgroundColor: "#FAFAFA", width: "25%" }),
  exclusiveBadge: z({
    position: "absolute",
    backgroundColor: "#333",
    padding: "2.6px 5.33px",
    justifyContent: "center",
    alignItems: "center",
    left: "50%",
    transform: "translateX(-50%)",
    top: "-0.5rem",
    borderRadius: "13px"
  })
}, P = {
  VARIABLE: "variable"
}, $ = (t) => {
  const { interest_rate_type: o, eibor_type: n, fixed_until: l = 0 } = t;
  return o === "variable" ? ` variable + ${n}` : ` fixed for ${l} year${l ?? 0 > 1 ? "s" : ""}`;
}, O = (t) => t.interest_rate_type === "variable" && (t != null && t.minimum_rate) && (t == null ? void 0 : t.minimum_rate) > 0 ? "" : t.eibor_type, H = (t) => t.interest_rate_type === P.VARIABLE && (t != null && t.minimum_rate) && (t == null ? void 0 : t.minimum_rate) > 0 ? t.minimum_rate : Number(t.variable_rate_addition), Y = (t) => {
  if (!t.is_exclusive)
    return "not applicable";
  const { description: o, expiry_date: n } = t;
  return o && n ? `${o} / ${n}` : o || n || "not applicable";
}, w = [
  "Monthly mortgage payment",
  "Rate terms",
  "Follow on rate",
  "Minimum Floor Rate",
  "Property Insurance",
  "Life insurance",
  "Over payment",
  "Bank processing fee",
  "Property valuation fee (fixed)",
  "Early settlement fee",
  "Customer profile",
  "Additional information",
  "Exclusive conditions (if applicable)"
], K = (t) => t.minimum_rate && t.minimum_rate > 0 ? t.minimum_rate : "No minimum rate set by bank", W = (t) => {
  var o;
  return [
    {
      key: w[0],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.monthly_payment ?? "-",
          thousandSeparator: ",",
          prefix: "AED "
        }
      )
    },
    {
      key: w[1],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.interest_rate_type === P.VARIABLE ? t.variable_rate_addition : t.interest_rate ?? "-",
          thousandSeparator: ",",
          suffix: "%"
        }
      ),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, $(t))
    },
    {
      // follow on Rate
      key: w[2],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: H(t),
          thousandSeparator: ",",
          suffix: "%"
        }
      ),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, O(t))
    },
    {
      key: w[3],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: K(t),
          thousandSeparator: ",",
          suffix: "%"
        }
      )
    },
    {
      key: w[4],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.property_insurance_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      ),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, "(", /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.property_insurance ?? "-",
          thousandSeparator: ",",
          suffix: "%"
        }
      ), " ", "per", " ", t.property_insurance_payment_period === "monthly" ? "month" : "annum", " ", "of the property value to be paid", " ", " ", t.property_insurance_payment_period, ")")
    },
    {
      key: w[5],
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.life_insurance ?? "-",
          thousandSeparator: ",",
          suffix: "%"
        }
      ), " ", "per", " ", t.life_insurance_payment_period === "monthly" ? "month" : "annum", " ", "on outstanding loan amount"),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, "(", /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.life_insurance_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      ), ")")
    },
    {
      key: w[6],
      node: t.overpayment_fee
    },
    {
      key: w[7],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.minimum_mortgage_processing_fee > t.mortgage_processing_fee_amount ? t.minimum_mortgage_processing_fee : t.mortgage_processing_fee_amount,
          prefix: "AED ",
          thousandSeparator: ","
        }
      ),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, "(", /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.mortgage_processing_fee,
          suffix: "%"
        }
      ), " ", "of loan amount )")
    },
    {
      key: w[8],
      node: /* @__PURE__ */ e.createElement(
        m,
        {
          value: t.home_valuation_fee,
          prefix: "AED ",
          thousandSeparator: ","
        }
      )
    },
    {
      key: w[9],
      node: t.early_settlement_fee
    },
    {
      key: w[10],
      node: t.customer_segments.map((n) => n.profile).join(", "),
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, (o = t.customer_segments.map((n) => n.description)) == null ? void 0 : o.join(", "))
    },
    {
      key: w[11],
      description: /* @__PURE__ */ e.createElement(a, { size: "md", dangerouslySetInnerHTML: { __html: t.additional_information } })
    },
    {
      key: w[12],
      description: /* @__PURE__ */ e.createElement(a, { size: "md" }, Y(t))
    }
  ];
}, N = () => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: "relative",
      bottom: "0.5px"
    }
  },
  /* @__PURE__ */ e.createElement("path", { d: "M6.2141 2.52961C6.16556 2.3992 6.04125 2.31256 5.9021 2.31214H4.55134C4.50424 2.31218 4.46224 2.28246 4.4466 2.23803L3.96173 0.863748C3.9131 0.733674 3.78882 0.647461 3.64995 0.647461C3.51108 0.647461 3.38681 0.733674 3.33817 0.863748L3.33706 0.867298L2.8533 2.23803C2.83769 2.28238 2.79581 2.31208 2.74878 2.31214H1.39758C1.25748 2.31204 1.13231 2.39967 1.08447 2.53136C1.03664 2.66304 1.07638 2.81058 1.18389 2.90042L2.33426 3.85463C2.36948 3.88386 2.38314 3.93171 2.36865 3.97512L1.88534 5.42441C1.8395 5.56191 1.88791 5.71326 2.00503 5.79864C2.12215 5.88403 2.28106 5.88381 2.39795 5.7981L3.58427 4.92822C3.62331 4.89962 3.67638 4.89962 3.71542 4.92822L4.90129 5.79788C5.01813 5.88388 5.17722 5.8843 5.29451 5.79892C5.4118 5.71354 5.46028 5.56202 5.41435 5.42441L4.93103 3.97424C4.91655 3.93082 4.93021 3.88297 4.96543 3.85374L6.11802 2.8982C6.22413 2.80762 6.26249 2.66047 6.2141 2.52961Z", fill: "white" })
), X = ["A", "B", "C"], Q = ({ bankOffers: t, showBankLogos: o = !0, primaryColor: n }) => {
  const l = S(() => t.map((r) => W(r)), [t]);
  return /* @__PURE__ */ e.createElement(v, { w: "100%", gap: p["spacing-20"] }, /* @__PURE__ */ e.createElement(E, { w: "100%" }, /* @__PURE__ */ e.createElement(
    f,
    {
      w: h(270),
      p: p["spacing-10"],
      ta: "center",
      style: { backgroundColor: n }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "lg",
        style: { color: "white" },
        weight: "semiBold"
      },
      "Offer details"
    )
  ), /* @__PURE__ */ e.createElement(
    f,
    {
      w: h(270),
      p: p["spacing-10"],
      flex: 1,
      style: { borderBottom: "1px solid black", borderColor: n }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "sm",
        color: "neutral.12"
      },
      "These figures are for illustrative purposes only and may differ at the final offer stage."
    )
  )), /* @__PURE__ */ e.createElement("table", { className: d.table }, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("th", { style: { flex: 1, borderBottom: "0.666px solid #999" } }), t.map((r, i) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: r.external_id,
      className: b(d.thBase, d.banksTh),
      style: { backgroundColor: x[i] }
    },
    r.is_exclusive && /* @__PURE__ */ e.createElement(
      E,
      {
        className: d.exclusiveBadge
      },
      /* @__PURE__ */ e.createElement(f, { pos: "relative", bottom: "0.5px" }, /* @__PURE__ */ e.createElement(N, null)),
      /* @__PURE__ */ e.createElement(a, { size: "xs", ml: "2px", style: { color: "white" } }, "Exclusive")
    ),
    /* @__PURE__ */ e.createElement(E, { justify: "center", align: "center" }, o ? /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(k, { src: r.bank_logo, h: h(35), width: h(80) })) : /* @__PURE__ */ e.createElement(a, { size: "lg" }, "Offer", " ", X[i]))
  ))), w.map((r, i) => /* @__PURE__ */ e.createElement("tr", { key: r }, /* @__PURE__ */ e.createElement(
    "th",
    {
      className: b(d.thBase, d.itemTh)
    },
    /* @__PURE__ */ e.createElement(a, { size: "md", weight: i === 0 ? "semiBold" : "regular" }, r)
  ), l.map((s, _) => {
    var u, c, y;
    return /* @__PURE__ */ e.createElement(
      "td",
      {
        className: d.thBase,
        key: `${(u = s[_]) == null ? void 0 : u.key}`,
        style: {
          backgroundColor: x[_],
          borderTop: 0,
          width: "25%"
        }
      },
      /* @__PURE__ */ e.createElement(E, { justify: "center", direction: "column" }, /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, (c = s[i]) == null ? void 0 : c.node), /* @__PURE__ */ e.createElement(a, { size: "md" }, (y = s[i]) == null ? void 0 : y.description))
    );
  })))));
}, Z = /* @__PURE__ */ new Set([
  "BUYOUT + EQUITY",
  "TRANSFER OF EXISTING MORTGAGE"
]), J = ({
  bankOffers: t,
  mortgageDetails: o,
  propertyDetails: n,
  fees: l,
  feesToShow: r,
  isInDIFC: i,
  landDepartmentFeeFinancedAmount: s
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const _ = i ? [
    {
      key: "title_deed_fee",
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md" }, "Title deed fee"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, "(fixed)")),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.title_deed_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    },
    {
      key: "withdrawal_of_caveat_fee",
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md" }, "Withdrawal of caveat fee"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, "(fixed)")),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.withdrawal_of_caveat_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    }
  ] : [
    {
      key: "transfer_center_fee",
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md" }, Z.has(o.typeOfTransaction) ? "Trustee fee" : "Transfer center fee"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, "(fixed) (inclusive of VAT)")),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.transfer_center_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    }
  ];
  let u = [
    {
      key: "land_department_transfer_fee",
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md" }, i ? "DIFC transfer fee" : "Land department fee"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, l.land_department_transfer_fee.fee_percentage * 100, `% of purchase price ${(n == null ? void 0 : n.state) === "Abu Dhabi" ? "" : `+ AED ${l.land_department_transfer_fee.fixed_fee_amount}`}`)),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.land_department_transfer_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )), !!s && /* @__PURE__ */ e.createElement(a, { size: "md" }, "(Out of", " ", /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.land_department_transfer_fee.total_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      ), ")")))
    },
    {
      key: "mortgage_registration_fee",
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md" }, `${i ? "DIFC " : ""}Mortgage registration fee`), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, i ? /* @__PURE__ */ e.createElement(e.Fragment, null, "(fixed)") : /* @__PURE__ */ e.createElement(e.Fragment, null, l.mortgage_registration_fee.fee_percentage * 100, " ", ` % of loan amount ${(n == null ? void 0 : n.state) === "Abu Dhabi" ? "" : `+ AED ${l.mortgage_registration_fee.fixed_fee_amount}`}`))),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.mortgage_registration_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    },
    {
      key: "mortgage_release_fee",
      node: /* @__PURE__ */ e.createElement(a, { size: "md" }, "Mortgage release fee"),
      rows: t.map((c) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: c.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: l.mortgage_release_fee.required_up_front_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    },
    ..._
  ];
  return u = u.filter((c) => r.includes(c.key)), u.length === 0 ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement(
    "th",
    {
      className: b(d.thBase, d.itemTh),
      style: {
        backgroundColor: x[2],
        borderRight: 0,
        width: "25%"
      }
    },
    /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, "Government fees")
  ), t.map((c) => (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */ e.createElement(
      "td",
      {
        key: c.external_id,
        className: d.thBase,
        style: {
          backgroundColor: x[2],
          borderTop: 0,
          width: "25%"
        }
      }
    )
  ))), u.map((c, y) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.createElement("tr", { key: y }, /* @__PURE__ */ e.createElement(
      "th",
      {
        className: b(d.thBase, d.itemTh),
        style: {
          backgroundColor: "#FAFAFA",
          borderRight: 0
        }
      },
      c.node
    ), c.rows.map((g, A) => /* @__PURE__ */ e.createElement(
      "td",
      {
        key: A,
        className: d.thBase,
        style: {
          backgroundColor: x[y],
          borderTop: 0,
          width: "25%"
        }
      },
      g
    )))
  )));
}, ee = ({ bankOffers: t }) => {
  const o = [
    {
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "sm", weight: "regular" }, "Bank processing fee")),
      rows: t.map((n) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: n.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: n.minimum_mortgage_processing_fee > n.mortgage_processing_fee_amount ? n.minimum_mortgage_processing_fee : n.mortgage_processing_fee_amount,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    },
    {
      node: /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, "Property valuation (fixed)"),
      rows: t.map((n) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: n.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: n.home_valuation_fee,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    }
  ];
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement(
    "th",
    {
      className: b(d.thBase, d.itemTh),
      style: {
        backgroundColor: x[2],
        borderRight: 0,
        width: "25%"
      }
    },
    /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, "Bank fees")
  ), t.map((n) => (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */ e.createElement(
      "td",
      {
        key: n.external_id,
        className: d.thBase,
        style: {
          backgroundColor: x[2],
          borderTop: 0,
          width: "25%"
        }
      }
    )
  ))), o.map((n, l) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.createElement("tr", { key: l }, /* @__PURE__ */ e.createElement(
      "th",
      {
        className: b(d.thBase, d.itemTh),
        style: {
          backgroundColor: "#FAFAFA",
          borderRight: 0
        }
      },
      n.node
    ), n.rows.map((r, i) => /* @__PURE__ */ e.createElement(
      "td",
      {
        key: i,
        className: d.thBase,
        style: {
          backgroundColor: x[l],
          borderTop: 0,
          width: "25%"
        }
      },
      r
    )))
  )));
}, te = ({
  bankOffers: t,
  mortgageDetails: o,
  fees: n,
  feesToShow: l,
  realEstateFeeFinancedAmount: r
}) => {
  const i = [
    ...l.includes("real_estate_fee") ? [
      {
        node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md", weight: "medium" }, "Real estate"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, "(", /* @__PURE__ */ e.createElement(
          m,
          {
            value: n.real_estate_fee.fee_percentage * 100,
            suffix: "%"
          }
        ), " ", "of purchase price) (inclusive of 5% VAT)")),
        rows: t.map((s) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: s.external_id }, /* @__PURE__ */ e.createElement(
          m,
          {
            value: n.real_estate_fee.required_up_front_fee_amount,
            thousandSeparator: ",",
            prefix: "AED "
          }
        )), !!r && /* @__PURE__ */ e.createElement(a, { size: "md" }, "(Out of", " ", /* @__PURE__ */ e.createElement(
          m,
          {
            value: n.real_estate_fee.total_fee_amount,
            thousandSeparator: ",",
            prefix: "AED "
          }
        ), ")")))
      }
    ] : [],
    {
      node: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, "Mortgage broker fee"), /* @__PURE__ */ e.createElement(a, { size: "md", weight: "regular" }, "fixed fee (inclusive of VAT)")),
      rows: t.map((s) => /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold", key: s.external_id }, /* @__PURE__ */ e.createElement(
        m,
        {
          value: o.consultationFee,
          thousandSeparator: ",",
          prefix: "AED "
        }
      )))
    }
  ];
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement(
    "th",
    {
      className: b(d.thBase, d.itemTh),
      style: {
        backgroundColor: x[2],
        borderRight: 0,
        width: "25%"
      }
    },
    /* @__PURE__ */ e.createElement(a, { size: "md", weight: "semiBold" }, "Other fees")
  ), t.map((s) => (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */ e.createElement(
      "td",
      {
        key: s.external_id,
        className: b(d.thBase, d.itemTh),
        style: {
          backgroundColor: x[2],
          borderTop: 0,
          width: "25%"
        }
      }
    )
  ))), i.map((s, _) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.createElement("tr", { key: _ }, /* @__PURE__ */ e.createElement(
      "th",
      {
        className: b(d.thBase, d.itemTh),
        style: {
          backgroundColor: "#FAFAFA",
          borderRight: 0
        }
      },
      s.node
    ), s.rows.map((u, c) => /* @__PURE__ */ e.createElement(
      "td",
      {
        key: c,
        className: d.thBase,
        style: {
          backgroundColor: x[_],
          borderTop: 0,
          width: "25%"
        }
      },
      u
    )))
  )));
}, C = (t, o, n, l) => {
  let r = (t.minimum_mortgage_processing_fee > t.mortgage_processing_fee_amount ? t.minimum_mortgage_processing_fee : t.mortgage_processing_fee_amount) + t.home_valuation_fee + n;
  return l.forEach((i) => {
    o[i] && (r += o[i].required_up_front_fee_amount);
  }), r;
}, ae = ({
  bankOffers: t,
  mortgageDetails: o,
  fees: n,
  feesToShow: l
}) => {
  const r = [
    {
      node: /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Total fees upfront"),
      rows: t.map((i) => /* @__PURE__ */ e.createElement(a, { size: "md", key: i.external_id, padding: "5px", weight: "semiBold" }, /* @__PURE__ */ e.createElement(
        m,
        {
          prefix: "AED ",
          decimalScale: 2,
          value: C(
            i,
            n,
            o.consultationFee,
            l
          ),
          thousandSeparator: ","
        }
      )))
    },
    {
      node: /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Downpayment"),
      rows: t.map((i) => /* @__PURE__ */ e.createElement(a, { size: "md", key: i.external_id, padding: "5px", weight: "semiBold" }, /* @__PURE__ */ e.createElement(
        m,
        {
          prefix: "AED ",
          decimalScale: 2,
          value: o.downpayment,
          thousandSeparator: ","
        }
      )))
    },
    {
      node: /* @__PURE__ */ e.createElement(a, { weight: "semiBold", size: "md" }, "Total required upfront"),
      rows: t.map((i) => /* @__PURE__ */ e.createElement(a, { size: "md", key: i.external_id, padding: "5px", weight: "semiBold" }, /* @__PURE__ */ e.createElement(
        m,
        {
          decimalScale: 2,
          prefix: "AED ",
          value: C(
            i,
            n,
            o.consultationFee,
            l
          ) + o.downpayment,
          thousandSeparator: ","
        }
      )))
    }
  ];
  return /* @__PURE__ */ e.createElement("table", { style: { borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" } }, r.map((i, s) => /* @__PURE__ */ e.createElement(
    "tr",
    {
      key: s
    },
    /* @__PURE__ */ e.createElement("th", { style: { flex: 1, width: "25%" } }, i.node),
    i.rows.map((_, u) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("td", { key: u, style: { width: "25%" } }, _, s + 1 < i.rows.length && /* @__PURE__ */ e.createElement(D, { size: "xs", color: "black" }))))
  )));
}, ne = ["A", "B", "C"], re = ({
  mortgageDetails: t,
  propertyDetails: o,
  bankOffers: n,
  showBankLogos: l = !0,
  fees: r,
  feesToShow: i,
  primaryColor: s
}) => {
  const _ = o.location === "DIFC";
  return /* @__PURE__ */ e.createElement(v, { w: "100%", gap: p["spacing-20"] }, /* @__PURE__ */ e.createElement(E, { w: "100%" }, /* @__PURE__ */ e.createElement(
    E,
    {
      w: h(270),
      p: p["spacing-10"],
      ta: "center",
      align: "center",
      justify: "center",
      style: { backgroundColor: s }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "lg",
        style: { color: "white" },
        weight: "semiBold"
      },
      "Transaction fees"
    )
  ), /* @__PURE__ */ e.createElement(
    f,
    {
      w: h(270),
      p: p["spacing-10"],
      flex: 1,
      style: { borderBottom: "1px solid black", borderColor: s }
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        size: "sm",
        color: "neutral.12"
      },
      "Our philosophy is to provide our customers with a transparent approach to securing mortgage finance and explain the charges associated with purchasing property in UAE. There are various charges payable to several parties and we aim to clearly set out what to expect, in order to avoid unpleasant surprises at a later date."
    )
  )), /* @__PURE__ */ e.createElement("table", { style: { borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" } }, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("th", { style: { flex: 1, borderBottom: "0.666px solid #999" } }), n.map((u, c) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: u.external_id,
      className: b(d.thBase, d.banksTh),
      style: { backgroundColor: x[c] }
    },
    u.is_exclusive && /* @__PURE__ */ e.createElement(
      E,
      {
        className: d.exclusiveBadge
      },
      /* @__PURE__ */ e.createElement(f, { pos: "relative", bottom: "0.5px" }, /* @__PURE__ */ e.createElement(N, null)),
      /* @__PURE__ */ e.createElement(a, { size: "xs", ml: "2px", style: { color: "white" } }, "Exclusive")
    ),
    /* @__PURE__ */ e.createElement(E, { justify: "center", align: "center" }, l ? /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(k, { src: u.bank_logo, h: h(35), width: h(80) })) : /* @__PURE__ */ e.createElement(a, { size: "md" }, ne[c]))
  ))), /* @__PURE__ */ e.createElement(
    J,
    {
      bankOffers: n,
      fees: r,
      feesToShow: i,
      mortgageDetails: t,
      propertyDetails: o,
      landDepartmentFeeFinancedAmount: r.land_department_fee_financed_amount,
      isInDIFC: _
    }
  ), /* @__PURE__ */ e.createElement(
    ee,
    {
      bankOffers: n
    }
  ), /* @__PURE__ */ e.createElement(
    te,
    {
      bankOffers: n,
      mortgageDetails: t,
      fees: r,
      feesToShow: i,
      realEstateFeeFinancedAmount: r.real_estate_fee_financed_amount
    }
  )), /* @__PURE__ */ e.createElement(
    ae,
    {
      bankOffers: n,
      fees: r,
      mortgageDetails: t,
      feesToShow: i
    }
  ), /* @__PURE__ */ e.createElement(f, { p: "10px", bg: "rgb(247, 242, 233)" }, /* @__PURE__ */ e.createElement(a, { size: "sm" }, /* @__PURE__ */ e.createElement("b", null, "Disclaimer:"), " ", "The stated transaction fees are for indicative purposes only and are subject to change without notice. VAT may be applied to any of the above charges without notice Mortgage terms and conditions are subject to change.")), /* @__PURE__ */ e.createElement(f, { p: "10px", bg: "rgb(247, 242, 233)" }, /* @__PURE__ */ e.createElement(F, { cols: 2 }, /* @__PURE__ */ e.createElement(a, { size: "sm" }, /* @__PURE__ */ e.createElement("b", null, "Important:"), " ", "The rates shown are based on the current daily EIBOR on the creation date of this proposal. Fees may vary on different dates."), /* @__PURE__ */ e.createElement(a, { size: "sm" }, "A pre-approval is valid for 30-90 days and varies from bank to bank."))));
}, oe = [
  {
    category: "IDENTIFICATION",
    items: ["Passport and Visa copies", "Emirates identification card - front & back"]
  },
  {
    category: "EMPLOYMENT DETAILS",
    items: [
      // eslint-disable-next-line max-len
      "Salary letter - original to include name, nationality, passport number, start date, designation, basic income, fixed allowances and any variable or guaranteed bonuses. This should be signed by a named representative of the company and stamped with company stamp",
      "Latest 6 months’ pay slips - originals or company stamped copies"
    ]
  },
  {
    category: "BANK DOCUMENTS",
    items: [
      "6 months’ personal bank statements - originals or bank stamped copies. These must be up to 1 week of submitting",
      "The application and show latest 6 salary credits",
      "Latest credit card statement Cheque book for bank pre approval (application) fee, if any"
    ]
  },
  {
    category: "SUPPORTING DOCUMENTS",
    description: "Check if needed:",
    items: [
      // eslint-disable-next-line max-len
      "If your current employment is less than 1 year, a letter or proof from your previous employer detailing length of service will be required",
      "Proof of deposit source",
      "Passport and visa copies of spouse",
      "Emirates identification card of spouse (front & back copies)",
      "Attested marriage certificate copy",
      "If joint income of applicants is being considered for loan eligibility, full documentation for both required"
    ]
  }
], ie = ({ primaryColor: t }) => /* @__PURE__ */ e.createElement(v, { w: "100%", gap: p["spacing-20"] }, /* @__PURE__ */ e.createElement(E, { w: "100%" }, /* @__PURE__ */ e.createElement(
  E,
  {
    w: h(270),
    p: p["spacing-10"],
    ta: "center",
    align: "center",
    justify: "center",
    style: { backgroundColor: t }
  },
  /* @__PURE__ */ e.createElement(
    a,
    {
      size: "sm",
      style: { color: "white" },
      weight: "semiBold"
    },
    "Required documents"
  )
), /* @__PURE__ */ e.createElement(
  f,
  {
    w: h(270),
    p: p["spacing-10"],
    flex: 1,
    style: { borderBottom: "1px solid black", borderColor: t }
  }
)), /* @__PURE__ */ e.createElement(B, null, /* @__PURE__ */ e.createElement(B.Col, { span: 10 }, /* @__PURE__ */ e.createElement(v, { gap: p["spacing-20"] }, oe.map(({ category: o, items: n, description: l }) => /* @__PURE__ */ e.createElement(v, { gap: p["spacing-10"], key: o }, /* @__PURE__ */ e.createElement(a, { size: "lg", color: "neutral.12", weight: "medium" }, o), l && /* @__PURE__ */ e.createElement(a, { size: "md", weight: "medium" }, l), n.map((r) => /* @__PURE__ */ e.createElement(R, { gap: p["spacing-6"], key: r, wrap: "nowrap" }, /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(M, { width: 16, height: 16, color: "#dcc69e " })), /* @__PURE__ */ e.createElement(a, { weight: "regular", size: "md" }, r))))))), /* @__PURE__ */ e.createElement(B.Col, { span: 2 }))), le = "#000", ge = ({
  config: t,
  proposal: o,
  brokerage: n,
  style: l
}) => {
  const { mortgageDetails: r, propertyDetails: i, calculatedFees: s } = S(() => ({
    ...o,
    mortgageDetails: {
      ...o.mortgageDetails,
      downpayment: L(o.mortgageDetails.typeOfTransaction) ? 0 : o.mortgageDetails.downpayment
    }
  }), [o]), { feesToShow: _, showBankLogos: u, showRequiredDocuments: c } = t, y = i.location === "DIFC" ? [
    ..._,
    "title_deed_fee",
    "withdrawal_of_caveat_fee"
  ] : _, g = n.primaryColor ?? le;
  return /* @__PURE__ */ e.createElement(
    E,
    {
      display: "flex",
      align: "center",
      direction: "column",
      id: "proposal-template",
      w: "100%",
      p: p["spacing-40"],
      style: { overflow: "hidden", ...l },
      maw: h(1300),
      miw: h(1300)
    },
    /* @__PURE__ */ e.createElement(E, { direction: "column", w: "100%" }, /* @__PURE__ */ e.createElement(f, null, /* @__PURE__ */ e.createElement(
      V,
      {
        clientName: o.clientName,
        brokerName: n.ownerName,
        brokerageLogo: n.logo,
        brokerageName: n.name
      }
    ), /* @__PURE__ */ e.createElement(v, { gap: p["spacing-24"], mt: p["spacing-32"] }, /* @__PURE__ */ e.createElement(
      j,
      {
        employmentStatus: r.employmentStatus,
        location: i.state,
        mortgageLength: r.mortgageLength,
        mortgageType: r.mortgageType,
        citizenStatus: r.citizenStatus,
        typeOfTransaction: r.typeOfTransaction,
        primaryColor: g
      }
    ), /* @__PURE__ */ e.createElement(
      G,
      {
        downpayment: r.downpayment,
        landDepartmentFeeFinancedAmount: s.land_department_fee_financed_amount,
        realEstateFeeFinancedAmount: s.real_estate_fee_financed_amount,
        loanAmount: r.loanAmount,
        propertyValue: i.propertyValue,
        loanToValueRatio: r.loanToValueRatio,
        primaryColor: g,
        typeOfTransaction: r.typeOfTransaction,
        equityReleaseAmount: r.equityReleaseAmount
      }
    )), /* @__PURE__ */ e.createElement(f, { mt: p["spacing-32"] }, /* @__PURE__ */ e.createElement(v, { gap: p["spacing-40"] }, /* @__PURE__ */ e.createElement(f, { style: { breakAfter: "page" } }, /* @__PURE__ */ e.createElement(
      Q,
      {
        bankOffers: o.bankOffers,
        showBankLogos: u,
        primaryColor: g
      }
    )), /* @__PURE__ */ e.createElement(
      re,
      {
        mortgageDetails: r,
        propertyDetails: i,
        bankOffers: o.bankOffers,
        fees: s,
        showBankLogos: u,
        feesToShow: y,
        primaryColor: g
      }
    ), c && /* @__PURE__ */ e.createElement(ie, { primaryColor: g })))))
  );
}, Ee = {
  config: {
    feesToShow: [],
    showBankLogos: !0,
    showRequiredDocuments: !0
  },
  proposal: {
    clientName: "Ahmad",
    calculatedFees: {
      real_estate_fee: {
        fee_percentage: 0.02,
        total_fee_amount: 4e4,
        financed_fee_amount: 0,
        calculated_fee_amount: 4e4,
        required_up_front_fee_amount: 4e4
      },
      transfer_center_fee: {
        total_fee_amount: 4200,
        required_up_front_fee_amount: 4200
      },
      mortgage_release_fee: { required_up_front_fee_amount: 0 },
      mortgage_registration_fee: {
        fee_percentage: 25e-4,
        fixed_fee_amount: 290,
        total_fee_amount: 2790,
        calculated_fee_amount: 2500,
        required_up_front_fee_amount: 2790
      },
      total_fee_financed_amount: 0,
      land_department_transfer_fee: {
        fee_percentage: 0.04,
        fixed_fee_amount: 580,
        total_fee_amount: 80580,
        financed_fee_amount: 0,
        calculated_fee_amount: 8e4,
        required_up_front_fee_amount: 80580
      },
      title_deed_fee: { required_up_front_fee_amount: 0 },
      withdrawal_of_caveat_fee: { required_up_front_fee_amount: 0 },
      land_department_fee_financed_amount: 1e5,
      real_estate_fee_financed_amount: 3e5
    },
    mortgageDetails: {
      employmentStatus: "Salaried",
      mortgageLength: "3 years and 3 months",
      mortgageType: "Conventional",
      citizenStatus: "UAE Resident",
      typeOfTransaction: "Primary purchase",
      downpayment: 1e6,
      loanAmount: 1e6,
      consultationFee: 3e5,
      loanToValueRatio: "Up to 50%",
      equityReleaseAmount: 0
    },
    propertyDetails: {
      state: "Dubai",
      propertyValue: 2e6,
      location: "Business Bay"
    },
    bankOffers: [
      {
        bank_logo: "https://huspy-apollo-public-production.s3.amazonaws.com/static/application/bank_entity/United%20Arab%20Bank/united_arab_bank_ok.png",
        bank_name: "United Arab Bank",
        external_id: "1",
        monthly_payment: 1e4,
        interest_rate: 3.89,
        fixed_until: 1,
        interest_rate_type: "fixed",
        variable_rate_addition: 1.79,
        eibor_type: "EIBOR 3 MONTH",
        life_insurance_amount: 4e3,
        minimum_rate: 3.34,
        property_insurance_amount: 3e3,
        property_insurance: 0.06,
        life_insurance: 0.0197,
        life_insurance_payment_period: "monthly",
        overpayment_fee: "Up to 20% of the outstanding loan amount",
        property_insurance_payment_period: "annualy",
        minimum_mortgage_processing_fee: 500,
        // eslint-disable-next-line unicorn/no-zero-fractions
        mortgage_processing_fee: 0.52,
        mortgage_processing_fee_amount: 468,
        home_valuation_fee: 3150,
        early_settlement_fee: "1.05% of the loan outstanding or AED 10,500 - whichever is lower",
        buyout_processing_fee: 0,
        customer_segments: [{
          profile: "Premier",
          type_of_account: "",
          description: "Follow On Rates to be offered for Premier & Specific Segments: 3 M EIBOR + 1.79% *Check the minimum salary and loan size"
        }],
        additional_information: `Key Points:
(1) Private Clients/Excellency/Emirati Customer
(2) Special Mortgage Pricing (*inclusive of 0.25% discount on fixed rate) for employees of specific companies/categories
(3) Golden visa holders get a 0.25% discount on processing fees by providing STL`,
        is_exclusive: !0,
        description: "Description",
        expiry_date: "11/11/2025"
      },
      {
        bank_logo: "https://huspy-apollo-public-production.s3.amazonaws.com/static/application/bank_entity/Abu%20Dhabi%20Commercial%20Bank/adcb_ok.png",
        bank_name: "Abu Dhabi Commercial Bank",
        external_id: "2",
        monthly_payment: 11e3,
        // eslint-disable-next-line unicorn/no-zero-fractions
        interest_rate: 3.89,
        minimum_mortgage_processing_fee: 500,
        fixed_until: 1,
        life_insurance_amount: 4e3,
        minimum_rate: 3.34,
        property_insurance_amount: 3e3,
        interest_rate_type: "fixed",
        variable_rate_addition: 1.79,
        eibor_type: "EIBOR 3 MONTH",
        property_insurance: 0.06,
        life_insurance: 0.0197,
        life_insurance_payment_period: "monthly",
        overpayment_fee: "Up to 20% of the outstanding loan amount",
        property_insurance_payment_period: "annualy",
        mortgage_processing_fee: 0.52,
        mortgage_processing_fee_amount: 468,
        home_valuation_fee: 3150,
        early_settlement_fee: "1.05% of the loan outstanding or AED 10,500 - whichever is lower",
        buyout_processing_fee: 0,
        customer_segments: [{
          profile: "Premier",
          type_of_account: "",
          description: "Follow On Rates to be offered for Premier & Specific Segments: 3 M EIBOR + 1.79% *Check the minimum salary and loan size"
        }],
        additional_information: `Key Points:
(1) Private Clients/Excellency/Emirati Customer
(2) Special Mortgage Pricing (*inclusive of 0.25% discount on fixed rate) for employees of specific companies/categories
(3) Golden visa holders get a 0.25% discount on processing fees by providing STL`,
        is_exclusive: !1,
        description: "Description",
        expiry_date: "11/11/2025"
      },
      {
        bank_logo: "https://huspy-apollo-public-production.s3.amazonaws.com/static/application/bank_entity/United%20Arab%20Bank/united_arab_bank_ok.png",
        bank_name: "United Arab Bank",
        external_id: "3",
        monthly_payment: 9e3,
        // eslint-disable-next-line unicorn/no-zero-fractions
        interest_rate: 3.89,
        fixed_until: 1,
        interest_rate_type: "fixed",
        variable_rate_addition: 1.79,
        minimum_mortgage_processing_fee: 500,
        eibor_type: "EIBOR 3 MONTH",
        property_insurance: 0.06,
        life_insurance: 0.0197,
        life_insurance_payment_period: "monthly",
        overpayment_fee: "Up to 20% of the outstanding loan amount",
        property_insurance_payment_period: "annualy",
        mortgage_processing_fee: 0.52,
        mortgage_processing_fee_amount: 468,
        life_insurance_amount: 4e3,
        minimum_rate: 3.34,
        property_insurance_amount: 3e3,
        home_valuation_fee: 3150,
        early_settlement_fee: "1.05% of the loan outstanding or AED 10,500 - whichever is lower",
        buyout_processing_fee: 0,
        customer_segments: [{
          profile: "Premier",
          type_of_account: "",
          description: "Follow On Rates to be offered for Premier & Specific Segments: 3 M EIBOR + 1.79% *Check the minimum salary and loan size"
        }],
        additional_information: `Key Points:
(1) Private Clients/Excellency/Emirati Customer
(2) Special Mortgage Pricing (*inclusive of 0.25% discount on fixed rate) for employees of specific companies/categories
(3) Golden visa holders get a 0.25% discount on processing fees by providing STL`,
        is_exclusive: !0,
        description: "Description",
        expiry_date: "11/11/2025"
      }
    ]
  },
  brokerage: {
    logo: "https://huspy-apollo-public-production.s3.amazonaws.com/static/application/company/Default%20Company/broker-company-logo-1656505185920.jpg",
    name: "Ankkttt",
    ownerName: "Ankit"
  }
};
export {
  Ee as PROPOSAL,
  ge as ProposalTemplate
};
